/* Numour Nook: blog post template */
(function () {
  function init(root) {
    if (!root || root.getAttribute('data-nook-ready')) return;
    root.setAttribute('data-nook-ready', '1');
    var content = root.querySelector('[data-nook-content]');
    if (!content) return;

    // wide tables scroll inside their own box
    Array.prototype.forEach.call(content.querySelectorAll('table'), function (t) {
      if (t.parentNode.className === 'nook-table') return;
      var w = document.createElement('div'); w.className = 'nook-table';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });

    // contents list, built from the H2s in the post
    var heads = content.querySelectorAll('h2');
    var lists = root.querySelectorAll('[data-nook-toc]');
    var wraps = root.querySelectorAll('[data-nook-toc-wrap]');
    var links = [];
    if (heads.length < 2) {
      Array.prototype.forEach.call(wraps, function (w) { w.style.display = 'none'; });
    } else {
      Array.prototype.forEach.call(heads, function (h, i) {
        if (!h.id) {
          h.id = 'read-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) + '-' + (i + 1);
        }
        Array.prototype.forEach.call(lists, function (ol) {
          var li = document.createElement('li'), a = document.createElement('a');
          a.href = '#' + h.id; a.textContent = h.textContent;
          li.appendChild(a); ol.appendChild(li); links.push(a);
        });
      });
      var mobile = root.querySelector('details[data-nook-toc-wrap]');
      if (mobile) mobile.addEventListener('click', function (e) { if (e.target.tagName === 'A') mobile.removeAttribute('open'); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (!en.isIntersecting) return;
            links.forEach(function (a) { a.classList.toggle('is-active', a.getAttribute('href') === '#' + en.target.id); });
          });
        }, { rootMargin: '-15% 0px -70% 0px' });
        Array.prototype.forEach.call(heads, function (h) { io.observe(h); });
      }
    }

    // reading progress
    var bar = root.querySelector('[data-nook-bar]');
    if (bar) {
      var ticking = false;
      var update = function () {
        ticking = false;
        var r = root.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
        bar.style.width = (p * 100).toFixed(2) + '%';
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update);
      update();
    }

    // copy link
    var copy = root.querySelector('[data-nook-copy]');
    if (copy) copy.addEventListener('click', function () {
      var url = window.location.href.split('#')[0];
      var done = function () {
        copy.textContent = copy.getAttribute('data-copied');
        setTimeout(function () { copy.textContent = copy.getAttribute('data-label'); }, 2200);
      };
      var fallback = function () {
        var ta = document.createElement('textarea'); ta.value = url; ta.setAttribute('readonly', '');
        ta.style.position = 'fixed'; ta.style.opacity = '0'; document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta); done();
      };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(url).then(done, fallback); } else { fallback(); }
    });
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('.nook-article'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
